import React from 'react';
import SalesDetailPage from './SalesDetailPage';
import { SORT_TYPES } from '../constants/sortTypes';
import {
  buildMemberFilterGroups,
  buildMemberApiFilters,
  memberColumns,
  memberReportBaseConfig,
  renderMemberCell,
} from '../constants/membershipReportShared';
import { currencyFormatter, compactCurrency } from '../utils/reportingUtils';

const DAYS_FILTER = { id: 'renews_days', label: 'Days Until Renewal' };

const RENEWAL_COLUMNS = memberColumns([
  { id: 'renews_at', label: 'Renews', defaultVisible: true, sortable: true, sortType: 'date' },
]);

const UPCOMING_RENEWALS_CONFIG = {
  ...memberReportBaseConfig({
    slug: 'upcoming-renewals',
    title: 'Upcoming Renewals',
    sidebarKey: 'memberships_upcoming_renewals',
    localStorageName: 'reportingMembershipsUpcomingRenewalsColumns',
  }),
  pageSubtitle: 'Members who are set to renew, soonest first, with the amount each renewal will charge.',
  columns: RENEWAL_COLUMNS.columns,
  sortTypes: SORT_TYPES,
  getDefaultVisibleColumns: RENEWAL_COLUMNS.getDefaultVisibleColumns,
  getDefaultHiddenColumns: RENEWAL_COLUMNS.getDefaultHiddenColumns,
  defaultSortRules: [{ field: 'renews_at', direction: 'asc' }],
  emptyMessage: 'No upcoming renewals.',

  buildFilterGroups: (venueOwnerships) => buildMemberFilterGroups({
    venueOwnerships, statuses: ['active', 'trialing'], daysFilter: DAYS_FILTER,
  }),
  buildDetailApiFilters: buildMemberApiFilters(DAYS_FILTER.id),

  buildKpiCards: (current) => [
    { label: 'Renewing in 30 Days', value: (current.renewing_30_days || 0).toLocaleString() },
    { label: 'Revenue in 30 Days', value: currencyFormatter.format(current.revenue_30_days || 0) },
    { label: 'Annual Renewals in 30 Days', value: (current.annual_renewing_30_days || 0).toLocaleString() },
    { label: 'Revenue in 90 Days', value: compactCurrency(current.revenue_90_days || 0) },
  ],

  renderCellValue: renderMemberCell(['renews_at']),
};

function ReportingMembershipsUpcomingRenewalsPage(props) {
  return <SalesDetailPage {...props} config={UPCOMING_RENEWALS_CONFIG} />;
}

export default ReportingMembershipsUpcomingRenewalsPage;
